<template>
  <div class="order-status-container">
    <div class="title">Tình trạng hoạt động trong ngày</div>
    <div class="status-container">
      <div class="status-item order-customer-status-total">
        <div>
          <span>Tổng số đơn hàng:</span>
        </div>
        <div class="value">
          <span class="number">{{ totalOrders}}</span>
          <span class="unit">đơn</span>
        </div>
      </div>
      <div :class="'status-item ' + item.styleClass"
        v-for="(item, index) in statusOrder"
        :key="index"
      >
        <div>
          <span>{{ item.text + ":"}}</span>
        </div>
        <div class="value">
          <span class="number">{{ item.count}}</span>
          <span class="unit">đơn</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import mixins from "@/mixins";
import moment from "moment/moment";
export default {
  mixins: [mixins],
  data() {
    return {
      dataParams: {
        fromDate: null,
        toDate: null,
      },
      totalOrders: 0,
      statusOrder: [],
    };
  },
  mounted() {
    this.reloadChartDate();
  },
  methods: {
    reloadChartDate: function () {
     const fromDate = moment().format("YYYY-MM-DD"),
          toDate = moment().format("YYYY-MM-DD");
      axios
        .get("c-report/status", {
          params: {
            fromDate,
            toDate,
          },
        })
        .then((res) => {
          const compareStatus = (status1, status2) => {
            return status1.sortOrder - status2.sortOrder;
          };
          this.statusOrder = this.orderCustmerStatus
            .concat()
            .sort(compareStatus)
            .map((x) => {
              console.log(x);
              const result = {
                status: x.id,
                text: x.text,
                styleClass: "order-customer-status-" + x.sortOrder,
              };
              let dataItem = null;
              let resultData = res.data;
              if(resultData.data && resultData.data.length > 0){
                dataItem = resultData.data.find(
                    (item) => +item.status == result.status
                );

              }
              result.count = dataItem ? dataItem.count : 0;
              this.totalOrders += result.count;
              return result;
            });
        })
        .finally(() => {
          // loader.hide();
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .order-status-container {
    padding: 12px 16px;
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .status-container {
      display: flex;
      align-items: center;
      margin: 16px 0;
      .order-customer-status-total{
        background-color: #11509b;
        color: #fff;
      }
      .order-customer-status-0 {
          background-color: #DF851B;
          color: #fff;
        }
        .order-customer-status-1 {
          background-color: #459B11;
          color: #FFFFFF;
        }
        .order-customer-status-2 {
          background-color: #9B2211;
          color: #FFFFFF;
        }
      .status-item {
        margin: 0 8px;
        display: inline-flex;
        height: 60px;
        flex: 1;
        border-radius: 8px;
        div{
          display: inline-flex;
          align-items: center;
        }
        div:first-child{
          padding: 8px 24px;
          padding-right: 8px;
          // max-width: 120px;
        }
        div.value{
          display: flex;
          flex-direction: row;
          justify-content: center;
          padding-right: 8px;
          span.number{
            font-size: 36px;
            font-weight: 700;
            margin-right: 8px;
          }
          span.unit{
            font-size: 12px;
          }
        }
      }
    }
  }
</style>